<ng-container *ngIf="_checkoutClientSecret">
    <ngx-stripe-payment [clientSecret]="_checkoutClientSecret">
    </ngx-stripe-payment>
    <div class="tr-stripe-save-card top5" (click)="$event.stopPropagation()" *ngIf="!isForSaveCard">
        <input type="checkbox" [value]="isSaveCard" [(ngModel)]="_isSaveCard" (click)="toggleSaveOption()"/>
        <span class="left5">Save Card for next payments</span>
    </div>
</ng-container>